package streetlight.web.model

import kampfire.api.Markdown
import kampfire.model.Messenger
import kampfire.model.toDataOr
import koala.utils.DropWhileBusy
import koala.utils.launch
import kampfire.model.tapOf
import kampfire.model.mutableTapOf
import kampfire.model.storeOf
import koala.dom.MarkdownEditor
import kotlinx.coroutines.CoroutineScope
import streetlight.model.data.Feedback
import streetlight.model.data.FeedbackEdit
import streetlight.model.data.Platform
import streetlight.web.io.FeedbackClient

/** Lists feedback and sends new feedback. */
class FeedbackHub(
    private val scope: CoroutineScope,
    private val api: FeedbackClient,
    private val toaster: Toaster,
) {
    private val sending = DropWhileBusy()
    private val state = storeOf(FeedbackHubState(FeedbackEdit(platform = Platform.Web)))
    val stateNow get() = state.now

    val feedFlow = state.tapOf { it.feed }
    val editState = state.mutableTapOf({ it.edit }) { copy(edit = it) }
    val textState = editState.mutableTapOf({ it.text }) { copy(text = it) }
    val feedbackTypeState = editState.mutableTapOf({ it.feedbackType }) { copy(feedbackType = it) }
    val isPrivateState = editState.mutableTapOf({ it.isPrivate} ) { copy(isPrivate = it) }

    init {
        scope.launch(::refreshFeedback) {
            refreshFeedback()
        }
    }

    fun sendFeedback(messenger: Messenger): Boolean {
        val edit = stateNow.edit.takeIf { it.isValid }?.copy(
            deviceAgent = readDeviceAgent()
        ) ?: return false
        return sending.launch(scope, ::sendFeedback.name) {
            messenger.deliverSending()
            api.createFeedback(edit).toDataOr(messenger, "Feedback Sent.") { return@launch }
            editState.set { copy(text = Markdown.Empty) }
            refreshFeedback()
        } != null
    }

    private suspend fun refreshFeedback() {
        val list = api.feedFeedback().toDataOr(toaster) { return }
        state.set { copy(feed = list) }
    }
}

data class FeedbackHubState(
    val edit: FeedbackEdit,
    val feed: List<Feedback> = emptyList(),
)